import { render } from "./DeleteEntry.vue?vue&type=template&id=1a35f950"
import script from "./DeleteEntry.vue?vue&type=script&lang=js"
export * from "./DeleteEntry.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__